import { render, staticRenderFns } from "./OrderRecord.vue?vue&type=template&id=001212f8&scoped=true"
import script from "./OrderRecord.vue?vue&type=script&lang=js"
export * from "./OrderRecord.vue?vue&type=script&lang=js"
import style0 from "./OrderRecord.vue?vue&type=style&index=0&id=001212f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001212f8",
  null
  
)

export default component.exports